import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=caf159fa&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=ts"
export * from "./Delivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf159fa",
  null
  
)

export default component.exports